export default __webpack_public_path__ + "static/media/KM.12bbb838.ico";